import React from 'react';
import PropTypes from 'prop-types';
import withLoading from '../../../../utils/composition/withLoading';
import { Pagination } from '../../../../v4/components';
import { dataProps, paginationProps } from '../../../../data/enums/Component';
import ReportTableStyled from './ReportTableStyled';
import { TableBody, TableHeader } from './tableConfig';

const propTypes = {
  data: dataProps.value,
  pagination: paginationProps.value,
  onPageChange: PropTypes.func,
  handleRowClick: PropTypes.func,
  onHeaderClick: PropTypes.func,
};

const defaultProps = {
  data: dataProps.defaultValue,
  pagination: paginationProps.defaultValue,
  onPageChange: () => null,
  handleRowClick: () => null,
  onHeaderClick: () => null,
};

const View = ({ ...props }) => {
  const { data, onPageChange, pagination, handleRowClick, onHeaderClick } = props;

  return (
    <ReportTableStyled>
      <div className='table-wrap'>
        <table>
          {TableHeader({ onHeaderClick })}
          <tbody>
            {data.list.map((report, index) =>
              TableBody({
                data: report,
                index,
                handleRowClick,
              }),
            )}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={pagination.page}
        limit={pagination.limit}
        totalItems={data.total}
        onPageChange={onPageChange}
      />
    </ReportTableStyled>
  );
};

View.propTypes = propTypes;

View.defaultProps = defaultProps;

const LoginViewWithErrorAndLoading = withLoading(View);

export default LoginViewWithErrorAndLoading;
